export default __webpack_public_path__ + "static/img_2_2-ca75c2e33dcb8e03d6ef5941343d5225.webp";